import { Frequency, Options, RRule } from '../lib/rrule';
import { parseRruleSafe } from './parse-rrule';

// rrule counts weekdays from Monday, Date counts from Sunday.
const toRruleWeekday = (date: Date) => (date.getDay() + 6) % 7;

const completeOptions = (
  options: Partial<Options>,
  startDate: Date,
): Partial<Options> | null => {
  if (options.freq === Frequency.YEARLY) {
    const namesADay = options.bymonthday != null || options.byweekday != null;

    if (options.bymonth != null && namesADay) {
      return null;
    }

    return {
      ...options,
      bymonth: options.bymonth ?? startDate.getMonth() + 1,
      ...(namesADay ? {} : { bymonthday: startDate.getDate() }),
    };
  }

  if (options.freq === Frequency.MONTHLY) {
    if (options.bymonthday != null || options.byweekday != null) {
      return null;
    }

    return { ...options, bymonthday: startDate.getDate() };
  }

  if (options.freq === Frequency.WEEKLY && options.byweekday == null) {
    return { ...options, byweekday: toRruleWeekday(startDate) };
  }

  return null;
};

// RFC 5545 leaves absent BY* parts to DTSTART, so the filled rule is occurrence-equivalent and saveable.
export const completeRruleFromStartDate = (
  rrule: string,
  startDate: Date,
): string => {
  const rule = parseRruleSafe(rrule);
  if (!rule) {
    return rrule;
  }

  const options = completeOptions(rule.origOptions, startDate);

  return options ? new RRule(options).toString() : rrule;
};
